var nirenfukuOddsTable = {
  props: ['voteInfo'],
  template: `
    <table class="table table-vote-number w100per">
      <tr class="text-center">
        <th></th>
        <th v-for="(item, key) in voteInfo.entries" :class="'bg-lighten-' + key">{{ key }}</th>
        <th></th>
      </tr>
      <tr class="text-center">
        <th>名前</th>
        <th v-for="(item, key) in voteInfo.entries" :class="'bg-lighten-' + key">{{ item.name }}</th>
        <th>名前</th>
      </tr>
      <tr class="text-center">
        <th>{{prefLabel()}}</th>
        <th v-for="(item, key) in voteInfo.entries" :class="'bg-lighten-' + key">{{ item.locker_ground || item.pref_name }}</th>
        <th>{{prefLabel()}}</th>
      </tr>
      <tr v-for="(row, syaban2) in voteInfo.entries" v-if="syaban2 > 1" class="text-center">
        <th :class="'bg-lighten-' + syaban2">{{ syaban2 }}</th>
        <td v-for="(col, syaban1) in voteInfo.entries">
          <a class="block" v-if="voteInfo.oddsTableData[ syaban1 + '-' + syaban2 ]" @click.prevent="addOddsTableItems(voteInfo.oddsTableData[ syaban1 + '-' + syaban2 ], syaban1 + '-' + syaban2)" :class="{'is-absent': !voteInfo.oddsTableData[syaban1 + '-' + syaban2 ].is_valid}">
            {{ voteInfo.oddsTableData[ syaban1 + '-' + syaban2 ].normalize_rate }}
          </a>
        </td>
        <th :class="'bg-lighten-' + syaban2">{{ syaban2 }}</th>
      </tr>
    </table>
  `
};

export default {
  nirenfukuOddsTable
}